import { GlAvatarLabeled, GlAvatarLink, GlIcon, GlSprintf } from '@gitlab/ui';
import TimeAgoTooltip from '~/vue_shared/components/time_ago_tooltip.vue';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import { VARIANT_DEFAULT, VARIANT_AVATAR } from '../../constants';
import { isValidVariant } from '../../utils';
import TargetLink from '../target_link.vue';
import ResourceParentLink from '../resource_parent_link.vue';
export default {
    name: 'ContributionEventBase',
    components: {
        GlAvatarLabeled,
        GlAvatarLink,
        GlIcon,
        GlSprintf,
        TimeAgoTooltip,
        TargetLink,
        ResourceParentLink
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        event: {
            type: Object,
            required: true
        },
        iconName: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: false,
            default: ''
        },
        /**
     * Variant for styling. Options:
     * - 'default': Shows event with icon only
     * - 'avatar': Shows event with the author avatar
     */ variant: {
            type: String,
            required: false,
            default: VARIANT_DEFAULT,
            validator: isValidVariant
        }
    },
    computed: {
        isDefaultVariant () {
            return this.variant === VARIANT_DEFAULT;
        },
        author () {
            return this.event.author;
        },
        authorUsername () {
            return `@${this.author.username}`;
        },
        variantClass () {
            const classes = {
                [VARIANT_DEFAULT]: 'contribution-event-default',
                [VARIANT_AVATAR]: 'contribution-event-avatar'
            };
            return classes[this.variant];
        }
    }
};
